import Vuex from "vuex";
import Vue from 'vue'
import {vuexfireMutations, firebaseAction} from "vuexfire";
import { db } from '@/fb/firebase'
import {guestProfileSettings} from "../helpers/configs";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accountData: {},
    linkedAccounts: {},
    linkedData: {},
    linkedUid: null,
    currentDeviceID: null,
    user: {},
    isRemote: true,
    fbUiShowing: false,
    hideWelcome: false,
    showLoginFormLoader: false,
  },

  mutations: {
    ...vuexfireMutations,

    showLoginFormLoader(state, payload) {
      state.showLoginFormLoader = payload;
    },
    setDeviceID(state, payload) {
      state.currentDeviceID = payload;
    },
    setUserID(state, payload) {
      state.user = payload
    },
    setUserName(state, payload) {
      state.user.displayName = payload
    },
    setIsRemote(state, payload) {
      state.isRemote = payload
    },
    temporaryProfileID(state, payload) {
      state.temporaryProfileID = payload
    },
    setFbUiShowing(state, payload) {
      state.fbUiShowing = payload
    },
    hidePMWelcome(state, payload) {
      state.hideWelcome = payload
    },
  },

  getters: {
    activeProfiles: state => {
      const settings = state.accountData;
      if (!settings.devices ) {
        return {};
      }

      const activeProfiles = {};
      for (const [key, value] of Object.entries(settings.devices)) {
        if (value.currentProfileID) {
          activeProfiles[value.currentProfileID] = {
            deviceName: value.name,
            deviceID: key,
          }
        }
      }
      return activeProfiles;
    },
    profileAtCurrentDevice: state => {
      const profileIDRelevantToDevice = state.accountData.devices[state.currentDeviceID].currentProfileID;
      console.log(state.currentDeviceID, profileIDRelevantToDevice);
      if (profileIDRelevantToDevice === 'guestProfileAtCurrentDevice') {
        return state.accountData.devices[state.currentDeviceID].guestProfileAtCurrentDevice;
      }
      return state.accountData.profiles[profileIDRelevantToDevice];
    },

    currentDevice: state => {
      return state.accountData.devices[state.currentDeviceID];
    },

    profileIdAtCurrentDevice: state => state.accountData.devices[state.currentDeviceID].currentProfileID,

    deviceCount: state => {
      return state.accountData && state.accountData.devices ? state.accountData.devices.length : 0;
    },

    profilesCount: state => {
      return state.accountData && state.accountData.profiles ? Object.keys(state.accountData.profiles).length : 0;
    },

    guestProfileAtCurrentDevice: state => {
      return state.accountData.devices && state.accountData.devices[state.currentDeviceID].guestProfileAtCurrentDevice || guestProfileSettings;
    },

    getUserRole: state => {
      if (!state.user.uid || !state.accountData.isRegistered) {
        return 'anonymous';
      }
      if (state.user.uid && state.accountData.isPremium) {
        return 'premium';
      }

      if (state.isRemote) {
        return 'remote';
      }

      return 'regular';
    },

    dataBaseId: state => {
      return state.user.isLinked ? state.user.mainUid : state.user.uid;
    },

    linkRequest: state => {
      const accountsLink = state.linkedData;
      if (!accountsLink) {
        return false;
      }

      let requestAccount = false;
      Object.keys(accountsLink).some((uid) => {
        if (accountsLink[uid].linkedEmails && accountsLink[uid].linkedEmails[state.user.uid]) {
          requestAccount = {
            mainAccountEmail: accountsLink[uid].mainAccountEmail,
            mainAccountUid: uid,
            status: accountsLink[uid].linkedEmails[state.user.uid].status,
            requestUid: state.user.uid,
            show: accountsLink[uid].linkedEmails[state.user.uid].show
          };
          return true;
        }
      })
      return requestAccount;
    },
  },

  actions: {
    bindAccountData: firebaseAction(({ bindFirebaseRef }, payload) => {
      return bindFirebaseRef('accountData', db.ref('users/' + payload.uid + '/settings'));
    }),
    bindLinkedAccounts: firebaseAction(({ bindFirebaseRef }, payload) => {
      return bindFirebaseRef('linkedAccounts', db.ref('accountBindings/' + payload.uid + '/linkedEmails'));
    }),
    bindLinkedData: firebaseAction(({ bindFirebaseRef }) => {
      return bindFirebaseRef('linkedData', db.ref('accountBindings'));
    }),
  },
})